import { render, staticRenderFns } from "./BrandListing.vue?vue&type=template&id=42906ddc&"
import script from "./BrandListing.vue?vue&type=script&lang=js&"
export * from "./BrandListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports